export default "__VITE_ASSET__C8c9NzEW__"